'use strict';

module.exports = function ($stateProvider) {
    $stateProvider
    .state('pages.main.search', {
        url: '/search',
        params: { include: null, exclude: null, time: null, mode: null },
        template: require('../views/search/search.html'),
        controller: 'searchController',
        controllerAs: 'page',
        data: {
            title: 'Search',
            daterange: true,
            manualSearch: true // this activates a button in the search bar and changes the auto search rules
        }
    })
}




/** WEBPACK FOOTER **
 ** ./src/pages/routes/search.js
 **/